module.exports = __webpack_public_path__ + "img/los-cabos-camellos.011b382d.jpg";